<template>
  <div class="language-switcher d-flex align-items-center">
    <img
      v-for="(entry, index) in languages"
      :key="index"
      :src="entry.flag"
      :alt="entry.title"
      height="20"
      class="rounded me-2"
      style="cursor: pointer"
      @click="setLanguage(entry.language, entry.title, entry.flag)"
    />
  </div>
</template>

<script>
import { ref, reactive, onMounted } from "vue";
import { useAuthUserStore } from "@/stores/useAuthUserStore";
import i18n from "@/i18n";
import { useMachineFilterStore } from "@/stores/machineFilterStore";

export default {
  name: "LanguageSwitcher",
  setup() {
    const authUserStore = useAuthUserStore();
    const filterStore = useMachineFilterStore();
    const languages = reactive([
      {
        flag: require("@/assets/images/flags/germany.svg"),
        language: "de",
        title: "Deutsch",
      },
      {
        flag: require("@/assets/images/flags/gb.svg"),
        language: "en",
        title: "English",
      },
    ]);

    const lan = ref(i18n.global.locale);

    // Methode zum Setzen der Sprache
    const setLanguage = (locale) => {
      lan.value = locale;
      i18n.global.locale = locale;
      authUserStore.setLanguage(locale);

      // Filter zurücksetzen
      filterStore.resetAll({});
    };

    // Initiale Sprache beim Laden setzen
    onMounted(() => {
      const defaultLocale =
        authUserStore.language || process.env.VUE_APP_I18N_LOCALE || "en";

      const selectedLanguage = languages.find(
        (lang) => lang.language === defaultLocale
      );

      if (selectedLanguage) {
        i18n.global.locale = defaultLocale;
      }
    });

    return {
      languages,
      lan,
      setLanguage,
    };
  },
};
</script>
